import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onExport, onStatusUpdate, onBatchDelete, onClearSelection }) => {
  const [showExportMenu, setShowExportMenu] = useState(false);
  const [showStatusMenu, setShowStatusMenu] = useState(false);

  const exportFormats = [
    { id: 'csv', label: 'Export as CSV', icon: 'FileText' },
    { id: 'excel', label: 'Export as Excel', icon: 'FileSpreadsheet' },
    { id: 'pdf', label: 'Export as PDF', icon: 'FileDown' }
  ];

  const statusOptions = [
    { id: 'delivered', label: 'Mark as Delivered', icon: 'CheckCircle2', color: 'success' },
    { id: 'in-transit', label: 'Mark as In Transit', icon: 'Truck', color: 'warning' },
    { id: 'exception', label: 'Mark as Exception', icon: 'AlertTriangle', color: 'error' }
  ];

  const handleExport = (format) => {
    onExport(format);
    setShowExportMenu(false);
  };

  const handleStatusUpdate = (status) => {
    onStatusUpdate(status);
    setShowStatusMenu(false);
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-32 left-1/2 -translate-x-1/2 z-150 animate-in slide-in-from-bottom-4 duration-200">
      <div className="bg-card border border-border rounded-lg shadow-elevation-4 px-24 py-18">
        <div className="flex items-center gap-24">
          <div className="flex items-center gap-12">
            <div className="w-[40px] h-[40px] rounded-full bg-primary/10 flex items-center justify-center">
              <span className="font-body font-semibold text-[14px] text-primary">
                {selectedCount}
              </span>
            </div>
            <span className="font-body text-[14px] text-foreground">
              {selectedCount === 1 ? '1 item selected' : `${selectedCount} items selected`}
            </span>
          </div>

          <div className="h-[32px] w-[1px] bg-border" />

          <div className="flex items-center gap-12">
            <div className="relative">
              <Button
                variant="outline"
                size="sm"
                iconName="Download"
                iconPosition="left"
                onClick={() => setShowExportMenu(!showExportMenu)}
              >
                Export
              </Button>

              {showExportMenu && (
                <>
                  <div 
                    className="fixed inset-0 z-10"
                    onClick={() => setShowExportMenu(false)}
                  />
                  <div className="absolute bottom-full left-0 mb-6 w-[200px] bg-card border border-border rounded-lg shadow-elevation-3 overflow-hidden z-20">
                    {exportFormats?.map(format => (
                      <button
                        key={format?.id}
                        onClick={() => handleExport(format?.id)}
                        className="w-full flex items-center gap-12 px-18 py-12 hover:bg-muted transition-smooth text-left"
                      >
                        <Icon 
                          name={format?.icon} 
                          size={18} 
                          color="var(--color-foreground)" 
                          strokeWidth={2} 
                        />
                        <span className="font-body text-[14px] text-foreground">
                          {format?.label}
                        </span>
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>

            <div className="relative">
              <Button
                variant="outline"
                size="sm"
                iconName="Edit"
                iconPosition="left"
                onClick={() => setShowStatusMenu(!showStatusMenu)}
              >
                Update Status
              </Button>

              {showStatusMenu && (
                <>
                  <div 
                    className="fixed inset-0 z-10"
                    onClick={() => setShowStatusMenu(false)}
                  />
                  <div className="absolute bottom-full left-0 mb-6 w-[220px] bg-card border border-border rounded-lg shadow-elevation-3 overflow-hidden z-20">
                    {statusOptions?.map(status => (
                      <button
                        key={status?.id}
                        onClick={() => handleStatusUpdate(status?.id)}
                        className="w-full flex items-center gap-12 px-18 py-12 hover:bg-muted transition-smooth text-left"
                      >
                        <Icon 
                          name={status?.icon} 
                          size={18} 
                          color={`var(--color-${status?.color})`}
                          strokeWidth={2} 
                        />
                        <span className="font-body text-[14px] text-foreground">
                          {status?.label}
                        </span>
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>

            <Button
              variant="destructive"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={onBatchDelete}
            >
              Delete
            </Button>

            <button
              onClick={onClearSelection}
              className="w-[32px] h-[32px] flex items-center justify-center rounded-lg hover:bg-muted transition-smooth"
              aria-label="Clear selection"
            >
              <Icon 
                name="X" 
                size={18} 
                color="var(--color-foreground)" 
                strokeWidth={2} 
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;